module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-top__layout"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "target-top__layout-summary-content",
    attrs: {
      "md6": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("\n        FEATURES\n        "), _c('v-icon', {
    staticClass: "features-more",
    attrs: {
      "id": "features-tooltip"
    }
  }, [_vm._v("info")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "icons-details"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "600",
      "padding": "0 0 2px 3px"
    }
  }, [_vm._v("When the icon is coloured it has the following meaning:")]), _vm._v(" "), _c('table', {
    staticClass: "icons-table"
  }, _vm._l((_vm.features), function(value, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('img', {
      staticStyle: {
        "background": "#ffffff"
      },
      attrs: {
        "src": value.imageValid,
        "height": "15",
        "width": "15"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.textValid))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-features', {
    attrs: {
      "target": _vm.target,
      "features": _vm.features
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "target-top__layout-summary-content",
    attrs: {
      "md6": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-subtitle"
  }, [_vm._v("CHARACTERIZATION")]), _vm._v(" "), _c('div', {
    staticClass: "target-top__layout__summary-content-main"
  }, [_c('prb-characterisation', {
    attrs: {
      "score": _vm.target.score
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e7cd93d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-target/prb-target-top/PrbTargetTop.vue
// module id = 562
// module chunks = 1